import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21129696")

_pushScopeId("data-v-21129696")
const _hoisted_1 = { class: "red-envelop-root" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "amount" }
const _hoisted_4 = { class: "content-info" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["content", !_ctx.isMobile ? 'desktop' : 'phone'],
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.userId) + " 恭喜您获得", 1),
      _createVNode("div", {
        class: "btn-close icon-close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.amount()), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("p", null, _toDisplayString(_ctx.message()), 1),
        _createVNode("p", null, "失效时间：" + _toDisplayString(_ctx.endDate()), 1)
      ])
    ], 2)
  ]))
})